/* common ajax method define  */
import {i18n} from './i18n'
import config from '../config'
import { alert, toast, loading } from './common'

// 开放平台错误码结构：
// {
//   "errors": [
//     {
//       "msg": "没有权限",
//       "code": "permission_denied"
//     }
//   ],
//   "request_id": "d6234a65-ccdc-4da6-90f1-2b7cc15f5529"
// }

export default function openAjax (options) {
  const props = {
    // credentials: 'include',
    method: options.method || 'GET'
  }

  const headers = {
    'Content-Type': options.contentType || 'application/json'
  }

  if (config.openConfig.accessToken) {
    headers['Authorization'] = `Bearer ${config.openConfig.accessToken}`
  }

  if (options.headers) {
    Object.assign(headers, options.headers)
  }
  props.headers = headers

  if (options.data) {
    props.method = 'post'
    props.body = options.formData ? options.data : JSON.stringify(options.data)
  }

  // const url = options.url.indexOf('?') > -1 ? `${options.url}&_=${+new Date()}` : `${options.url}?_=${+new Date()}` //fix ie cache
  const urlPrefix = config.openRequestUrl + (options.urlPrefix || config.openUrlPrefix)
  // global loading

  // options.loading: true or loading text, if true, use default '加载中'
  let ld
  if (options.loading) {
    ld = loading(typeof options.loading === 'string' ? options.loading : undefined)
  }
  return fetch(urlPrefix + options.url, props).then(response => {
    // console.log(response)
    if (response.status === 500) {
      alert({
        title: i18n.t('base.alert.server500.title'),
        message: i18n.t('base.alert.server500.content')
      })
    } else if (response.status === 502) {
      alert(i18n.t('base.alert.server502'))
    } else if (response.status === 504) {
      alert(i18n.t('base.alert.server504'))
    } else if (response.status === 404) {
      alert(i18n.t('base.alert.server404'))
    } else if (response.status === 403) {
      alert(i18n.t('base.alert.server403'))
    } else {
      ld && ld.clear()
      return response.json()
    }
    // resolve confirm promise when fail to fetch
    if (options.resolve) {
      options.resolve(false)
    }
  }).then(result => {
    if (!result) return false
    // toast
    if (result.success && options.successMessage) {
      toast.success(options.successMessage)
    }
    // 回传参数
    result.requestQuery = options.requestQuery
    // resolve confirm promise
    if (options.resolve) {
      options.resolve(result.success)
    }
    if (result.success || (options.accept_all_errors && result.errors) || (options.accept_errors && result.errors && options.accept_errors.includes(result.errors[0].code))) {
      if (options.parser) {
        result = options.parser(result)
      }
      return result
    }

    if (result.errors) {
      const errors = result.errors
      if (errors[0].code === 'permission_denied') {
        alert(i18n.t('base.noPermission')).then(() => {
          options.errorCallBack && options.errorCallBack()
        })
      } else if (errors.length > 0) {
        var error = errors[0]
        alert(error.msg).then(() => {
          options.errorCallBack && options.errorCallBack()
        })
      }
    }
    return result
  }).catch(e => {
    if (!options.skipNetworkError) {
      if (e.toString() === 'TypeError: Failed to fetch') {
        alert(i18n.t('base.failToFetch'))
      } else if (e.toString() === 'TypeError: NetworkError when attempting to fetch resource.') {
        // 火狐未请求完成，不再弹窗
      } else {
        alert(e.toString())
      }
    } else {
      if (e) {
        e.fetchError = true
      }
      throw e
    }
    // eslint-disable-next-line
    console.error(e);
  })
}
